;(function() {
  'use strict'

  service.$inject = ["$q", "$rootScope", "$log", "surveysService", "surveyFactory", "surveysResource", "AUTH_EVENTS", "communityService"];
  angular.module('core.services').factory('surveyStreamService', service)

  /* @ngInject */
  function service(
    $q,
    $rootScope,
    $log,
    surveysService,
    surveyFactory,
    surveysResource,
    AUTH_EVENTS,
    communityService
  ) {
    var log = $log.create('surveyStreamService')

    $rootScope.$on(AUTH_EVENTS.loginSuccess, refresh)
    $rootScope.$on(AUTH_EVENTS.logoutSuccess, refresh)
    $rootScope.$on(communityService.Events.JOINED, refresh)
    $rootScope.$on(communityService.Events.LEFT, refresh)
    $rootScope.$on('survey:responded', refresh)

    var states = {
      IDLE: 'idle',
      LOADING: 'loading',
      READY: 'ready',
      NONE: 'none',
      ERROR: 'error',
    }

    var surveys = {
      list: [],
      refresh: refresh,
      reset: reset,
      state: states.IDLE,
    }

    refresh()

    return surveys

    function refresh() {
      surveys.promise = $q(function(resolve, reject) {
        surveys.state = states.LOADING
        fetch().then(
          function(response) {
            angular.copy(response, surveys.list)
            surveys.state = response.length > 0 ? states.READY : states.NONE
            resolve(surveys.list)
            log.info('refreshed', response.length)
          },
          function(err) {
            surveys.state = states.ERROR
            reject(err)
          }
        )
      })
      return surveys.promise
    }

    function reset() {
      angular.copy([], surveys.list)
      surveys.state = states.IDLE
      log.info('reset')
    }

    function fetch() {
      return $q(function(resolve, reject) {
        surveysResource
          .getStream()
          .success(function(res, data) {
            surveyFactory.transform(data)
            resolve(data)
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }
  }
})()
